import React from "react";
import { Spinner } from "react-bootstrap";
import { BsArrowRight } from "react-icons/bs";
import ImageProfileUploader from "../../../Components/ImageProfileUploader";
import { ConvertDate } from "../../../Utils/functions";
import { useProfile } from "../Hooks";
import { Calendar } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
const Completion = () => {
  const { loading, user, submit, handler, updateImageProfile, navigate } =
    useProfile();

  return (
    <div className="profile-edit">
      <header className="d-flex justify-content-between">
        <div className="d-flex  align-items-center">
          <button
            className="btn"
            onClick={() => {
              navigate(-1);
            }}
          >
            <BsArrowRight />
          </button>
          <p className="fs-12 m-0">اطلاعات پروفایل</p>
        </div>
      </header>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <ImageProfileUploader
              preview={user?.user?.photo && user?.user?.photo[0]}
              onChange={files => {
                updateImageProfile(files[0]);
              }}
              loading={loading.imageProfile}
            />
          </div>
        </div>
        <div className="row g-3">
          <div className="col-lg-6">
            {" "}
            <label className="form-label" htmlFor="first-name">
              نام و نام خانوادگی
            </label>
            <input
              className="form-control"
              id="first-name"
              type="text"
              defaultValue={user?.user?.fullname}
              onChange={({ target: { value } }) => {
                handler("fullname", value);
              }}
            />
          </div>

          <div className="col-lg-6">
            {" "}
            <label className="form-label" htmlFor="email1">
              موبایل
            </label>
            <input
              className="form-control"
              id="number"
              disabled={true}
              type="text"
              defaultValue={user?.user?.mobile}
            />
          </div>
          <div className="col-lg-6">
            {" "}
            <label className="form-label" htmlFor="email2">
              ایمیل
            </label>
            <input
              className="form-control"
              id="email2"
              type="email"
              defaultValue={user?.user?.email}
              onChange={({ target: { value } }) => {
                handler("email", value);
              }}
            />
          </div>
          <div className="col-lg-6">
            {" "}
            <label className="form-label" htmlFor="email2">
              جنسیت
            </label>
            <select
              className="form-control"
              id="email2"
              type="text"
              defaultValue={user?.user?.sex}
              onChange={({ target: { value } }) => {
                handler("sex", value);
              }}
            >
              <option>انتخاب کنید</option>
              <option value={"male"}>آقا</option>
              <option value={"female"}>خانم</option>
            </select>
          </div>
          <div className="col-lg-6">
            <div className="col-md-4 mt-2">
              <label className="form-label" htmlFor="email2">
                تاریخ تولد
              </label>
              <Calendar
                onChange={data => {
                  handler(
                    "br_day",
                    ConvertDate(`${data.year}/${data.month.number}/${data.day}`)
                  );
                }}
                calendar={persian}
                locale={persian_fa}
                format="MM/DD/YYYY"
                // value="05/18/2020"
                // value={ToDateJalali(user?.user?.br_day)}
              />
            </div>
          </div>
          <div className="col-12 d-flex justify-content-end">
            <button className="btn btn-primary" onClick={submit}>
              {loading.edit ? <Spinner size="sm" /> : "به روز رسانی"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Completion;
